import type { ScheduledOrder, ScheduledOrderDetail } from '../../domain';
import type {
  ScheduledOrderDetailResponse,
  ScheduledOrderResponse,
} from '../responses';

export const scheduleOrderAdapter = {
  toScheduledOrder,
  toScheduledOrderDetail,
} as const;

function toScheduledOrder(response: ScheduledOrderResponse): ScheduledOrder {
  return {
    orderId: response.order_id,
    storeId: response.store_id,
    storeName: response.store_name,
    createdAt: response.created_at,
    placeAt: response.place_at,
  };
}

function toScheduledOrderDetail(
  response: ScheduledOrderDetailResponse,
): ScheduledOrderDetail {
  const { order_detail } = response;

  const clientName =
    response.user_info ||
    `${order_detail.application_user.first_name} ${order_detail.application_user.last_name}`;

  return {
    orderId: response.order_id,
    storeId: response.store_id,
    storeName: order_detail.store.name,
    clientName,
    createdAt: response.created_at,
    placeAt: response.place_at,
    subtotal: response.subtotal,
    products: order_detail.products.map(product => ({
      id: product.id,
      name: product.name,
      description: product.description,
      units: product.pivot.units || product.quantity,
      unitPrice: product.pivot.unit_price,
      totalPrice: product.pivot.total_price,
      toppings: (product.toppings ?? []).map(topping => ({
        id: topping.order_product_topping_id,
        description: topping.description,
        units: topping.units,
        price: topping.price,
        categoryId: topping.category_id,
        categoryDescription: topping.category_description,
      })),
    })),
  };
}
